// Percorso file: src/components/NavBand.jsx
//
// Banda di navigazione comune — doc 07 §7.2 (revisione 2A).
//
//   - metà sinistra «‹ Back»: c'è solo se la pagina passa `backTo`.
//     Sulle home di primo livello si omette (Back non ha significato).
//     `backTo` è di norma una ROTTA (stringa), e allora il Back ci va;
//     può però essere una FUNZIONE, e allora il Back si limita a
//     chiamarla (cantiere View Profile, fase 3). Serve alla scheda del
//     tesserato, la sola pagina il cui «indietro» non è una
//     destinazione fissa: si torna DA DOVE SI È VENUTI — cinque punti
//     d'ingresso diversi, più la pila dei profili collegati — e la
//     pagina che lo sa è quella, non questa banda. Le pagine che
//     passano una rotta non cambiano di una riga.
//   - metà destra «Switch role ⇄»: visibile solo se la persona possiede
//     almeno 2 ruoli (diario, INTEGRAZIONE AL CONTRATTO: «SWITCH
//     visibile solo con ≥2 ruoli totali»).
//
// Se non c'è nessuna delle due metà la banda non viene disegnata.
// Icone Font Awesome via react-icons (doc 07 §5: emoji abolite).

import React from "react";
import { useNavigate } from "react-router-dom";
import { FaChevronLeft, FaExchangeAlt } from "react-icons/fa";
import { useAuth } from "../context/AuthContext";
import { getActiveRoles } from "../auth/access";
import "./NavBand.css";

const NavBand = ({ backTo = null, showSwitch = true }) => {
  const navigate = useNavigate();
  const { user } = useAuth();

  const showBack = Boolean(backTo);
  const canSwitch = showSwitch && getActiveRoles(user).length >= 2;

  if (!showBack && !canSwitch) return null;

  return (
    <nav className="qpsc-navband">
      {showBack && (
        <button
          type="button"
          className="qpsc-navband__half"
          onClick={() =>
            typeof backTo === "function" ? backTo() : navigate(backTo)
          }
        >
          <span className="qpsc-navband__icon">
            <FaChevronLeft />
          </span>
          Back
        </button>
      )}

      {canSwitch && (
        <button
          type="button"
          className="qpsc-navband__half"
          onClick={() => navigate("/home/context")}
        >
          Switch role
          <span className="qpsc-navband__icon">
            <FaExchangeAlt />
          </span>
        </button>
      )}
    </nav>
  );
};

export default NavBand;
